import { render } from "./master_data.html?vue&type=template&id=2045f34b&external"
import script from "./master_data.js?vue&type=script&lang=js&external"
export * from "./master_data.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__